// extracted by mini-css-extract-plugin
export default {"items":"expertize-estimates_items__e-Xff","item":"expertize-estimates_item__CqGoz","key":"expertize-estimates_key__wBXCk"};